module.exports = __webpack_public_path__ + "img/02.f8e816c9.jpg";